import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  chats: "",
  chat:'',
};

const chatSlice = createSlice({
  name: "chat",
  initialState: initialState,
  reducers: {
    getChats(state, payload) {
      state.chats = payload.payload.response;
    },
    sendMessage(state, payload) {
      state.chat = payload.payload.response;
  },

  },
});

export default chatSlice.reducer;
export const chatActions = chatSlice.actions;
